// extracted by mini-css-extract-plugin
export default {"layout":"app_layout__cm1xu","content":"app_content__kzxes"};